/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * Indicates the billing method for the customer. It can either be a `recurring` billing cycle or a `onetime` payment.
 */
export const ProductBillingType = {
  Recurring: "recurring",
  Onetime: "onetime",
} as const;
/**
 * Indicates the billing method for the customer. It can either be a `recurring` billing cycle or a `onetime` payment.
 */
export type ProductBillingType = ClosedEnum<typeof ProductBillingType>;

/** @internal */
export const ProductBillingType$inboundSchema: z.ZodNativeEnum<
  typeof ProductBillingType
> = z.nativeEnum(ProductBillingType);
/** @internal */
export const ProductBillingType$outboundSchema: z.ZodNativeEnum<
  typeof ProductBillingType
> = ProductBillingType$inboundSchema;
